import {combineReducers} from 'redux'
import user from './user'
import jobDraft from './jobDraft'
const rootReducer = combineReducers({
    user,
    jobDraft
})
export default rootReducer